<template>
  <div class="automotive-wrapper">
    <app-markets-nav :navItems="navItems"></app-markets-nav>
    <div class="automotive-content">
      <h4 class="automotive-h4 indent" id="automotive-1">Panoramica</h4>
      <p class="automotive-p indent">L'alluminio è un metallo forte, durevole e leggero. Nella società odierna, attenta ai consumi energetici, queste tre proprietà di base si combinano per fare del metallo il materiale da costruzione preferito per le applicazioni nel trasporto, dove la riduzione del peso per diminuire il consumo di carburante ed aumentare la capacità di carico è vitale.</p>
      <p class="automotive-p indent">Alcomet produce estrusi personalizzati ed un'ampia gamma di prodotti laminati, come foglio di alluminio, lamiere e bobine per tutti i settori dell'industria automobilistica. Contattaci oggi stesso con la tua richiesta.
      </p>
      <div class="automotive-img" :style="{backgroundImage: 'url(' + '/static/img/markets/automotive/img_1.jpg' + ')'}"></div>
      <h4 class="automotive-h4 indent" id="automotive-2">Nastri per scudi termici</h4>
      <p class="automotive-p indent">Con le sue specifiche proprietà fisiche - riflettività, conducibilità termica e resistenza alla corrosione - l'alluminio è il materiale perfetto per la protezione termica offrendo un'eccellente protezione contro le alte temperature dei sistemi di scarico.</p>
      <div class="automotive-img" :style="{backgroundImage: 'url(' + '/static/img/markets/automotive/img_2.jpg' + ')'}"></div>
      <h4 class="automotive-h4 indent" id="automotive-3">Finstock</h4>
      <p class="automotive-p indent">L'alluminio ha un insieme di caratteristiche uniche che lo rendono ideale per gli scambiatori di calore. Con le sue proprietà distintive - leggerezza, buona conducibilità termica ed elettrica e resistenza alla corrosione - l'alluminio ha una vasta applicazione nei moderni sistemi HVAC (riscaldamento, ventilazione e condizionamento dell'aria) e di refrigerazione.</p>
      <!-- <div class="automotive-img" :style="{backgroundImage: 'url(' + '/static/img/markets/automotive/img_3.jpg' + ')'}"></div> -->
      <h4 class="automotive-h4 indent" id="automotive-4">Mancorrenti / portapacchi</h4>
      <p class="automotive-p indent">Un'importante applicazione degli estrusi di alluminio sono i mancorrenti. Le barre di alluminio sono posizionate sulla parte superiore del veicolo e vengono utilizzate per trasportare bagagli e attrezzature aggiuntive. Gli estrusi di alluminio sono utilizzati per la produzione di mancorrenti perché consentono di ottenere un design esteticamente attraente, leggero e ad alta resistenza.</p>
      <h4 class="automotive-h4 indent" id="automotive-5">Finiture decorative</h4>
      <p class="automotive-p indent">Per finiture si intende qualsiasi cosa che il produttore applica all'auto per migliorarne lo stile e l'aspetto. Strisce decorative e funzionali intorno al veicolo sono parte integrante del design del veicolo. A seconda della lega applicata, le diverse lavorazione portano a superfici che vanno dal lucido all'opaco, dal colore naturale all'alluminio nero.</p>
      <p class="automotive-p indent">Di conseguenza, l'alluminio è sempre più il materiale di elezione per decorazioni di alta qualità e obiettivi di design all'interno delle auto di oggi.</p>
      <p class="automotive-p indent">Nel suo impianto di estrusione Alcomet è in grado di estrudere una grande varietà di profili per automotive a seconda delle vostre necessità.</p>
      <router-link class="automotive-link" to="/contacts/factory-location">Contattateci oggi stesso con la vostra richiesta.</router-link>
      <!-- <div class="automotive-img" :style="{backgroundImage: 'url(' + '/static/img/markets/automotive/img_4.jpg' + ')'}"></div> -->
      <h4 class="automotive-h4 indent" id="automotive-6">Scambiatori di calore</h4>
      <p class="automotive-p indent">L'alluminio è il materiale preferito per un settore sempre più diversificato ed esigente quale quello della produzione di scambiatori di calore, ed è utilizzato in tutto il mondo in molte industrie, compreso il settore automobilistico, per numerose tipologie di scambiatori di calore. L'alluminio offre una combinazione unica di vantaggi, come ad esempio il costo, la resistenza, la durata alla corrosione, il basso peso, le caratteristiche di lavorazione, e la capacità di combinare le proprietà particolari del materiale con le specifiche applicazioni del cliente.</p>
      <!-- <div class="automotive-img" :style="{backgroundImage: 'url(' + '/static/img/markets/automotive/img_5.jpg' + ')'}"></div> -->
      <app-share-button></app-share-button>
    </div>
  </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
import MarketsNav from "./MarketsNav";
export default {
  components: {
    appShareButton: ShareButton,
    appMarketsNav: MarketsNav
  },
  data() {
    return {
      navItems: [
        ["automotive-1", "Panoramica"],
        ["automotive-2", "Nastri per scudi termici"],
        ["automotive-3", "Finstock"],
        ["automotive-4", "Mancorrenti / portapacchi"],
        ["automotive-5", "Finiture decorative"],
        ["automotive-6", "Scambiatori di calore"],
      ]
    };
  }
};
</script>

<style scoped>
.automotive-wrapper {
  align-items: center;
  display: flex;
  justify-content: center;
  padding-bottom: 20px;
}
/* CONTENT */
.automotive-content {
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 80%;
}
.automotive-p {
  font-size: 19px;
  margin: 15px 0;
  text-align: justify;
  line-height: 32px;
  width: 60%;
}
.automotive-link {
  font-size: 19px;
  text-decoration: underline;
}
.automotive-h4 {
  font-size: 22px;
  font-weight: 500;
  line-height: 32px;
  margin: 15px 0;
  text-align: justify;
  width: 60%;
}
.automotive-img {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 5px;
  min-height: 280px;
  margin: 20px 0;
  width: 80%;
}
@media screen and (max-width: 1000px) {
  .automotive-content {
    width: 100%;
  }
  .automotive-h4 {
    font-size: 18px;
    padding: 0 30px;
    width: 100%;
  }
  .automotive-p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
  .automotive-link {
    font-size: 16px;
  }
  .automotive-img {
    min-height: 30vw;
    margin: 20px 30px;
    width: calc(100% - 60px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/markets/Automotive.vue